import { Collapse } from 'react-bootstrap';

import { Accordion } from 'components/Accordion/Accordion';
import { Input, ToggleLabel } from 'components/FormComponents';

const settingsHeader = <span className="text-neutral-7 text-xl font-medium">Settings</span>;

export const DateSettings = ({ register, name, field }) => (
  <div className="flex flex-col bg-neutral-1 overflow-hidden u-margin-top">
    <Accordion defaultCollapsed={false} header={settingsHeader}>
      <div className="border border-neutral-4 rounded-2xl overflow-hidden">
        <div className="p-2 border-b border-neutral-4">
          <ToggleLabel register={register} name={`${name}.required`} label="Required" />
        </div>
        <div className="p-2 border-b border-neutral-4">
          <ToggleLabel
            register={register}
            name={`${name}.options.useDefault`}
            label='Use "current" as default'
          />
        </div>
        <div className="p-2">
          <ToggleLabel
            register={register}
            name={`${name}.use_description`}
            label="Add description"
          />
          <Collapse in={field.use_description}>
            <div>
              <Input
                register={register}
                name={`${name}.description`}
                className="u-margin-top--small"
                placeholder="Enter description..."
              />
            </div>
          </Collapse>
        </div>
      </div>
    </Accordion>
  </div>
);
